import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'

function InvoiceStatusSelect({ statusTypes, isLoading, selectedStatus, onStatusChange, disabled }) {

    return (
        <FormControl sx={{ minWidth: 120, ml: 2 }} size="small">

            {isLoading ? <Box
                sx={{
                    border: '1px solid #ccc',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                }}>
                <Typography variant="body2" sx={{ flexGrow: 1 }}>
                    Status
                </Typography>
                <CircularProgress size={20} />
            </Box>
                :
                <>
                    <InputLabel id="invoice-status-label">Status</InputLabel>
                    <Select
                        labelId="invoice-status-label"
                        id="invoice-status-select"
                        value={selectedStatus}
                        label="Status"
                        disabled={disabled}
                        onChange={(e) => onStatusChange(e.target.value)}
                    >
                        {statusTypes.data.map((statusOption) => (
                            <MenuItem key={statusOption} value={statusOption} sx={{textTransform: 'capitalize' }}>{statusOption}</MenuItem>
                        ))
                        }
                    </Select>
                </>

            }
        </FormControl>
    )
}

export default InvoiceStatusSelect